<template>
  <section class="cta">
    <div class="container">
      <div class="row row--gutter-xl">
        <div class="col cta__col">
          <AppCard class="text--center">
            <h2 class="cta__heading">
              Get Pre-Approved for Your Car Loan
            </h2>
            <p class="cta__text">
              Your online application takes only 3 minutes to complete
              and we only ask for information we actually need.
            </p>
            <AppButtonContinue
              v-data-layer="handleDataLayer"
              class="cta__button"
              @click="$emit('cta-click')"
            >
              Get Pre-Approved
            </AppButtonContinue>
          </AppCard>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import AppCard from '@/components/common/cards/AppCard'
import cookies from '@/mixins/cookies'
import AppButtonContinue from '@/components/common/buttons/AppButtonContinue'
import DataLayer from '../../../../../data-layer'

export default {
  // Name
  name: 'GetApprovedCTA',

  // Components
  components: {
    AppCard,
    AppButtonContinue
  },

  mixins: [cookies],

  methods: {
    handleDataLayer () {
      DataLayer.track({
        event: 'gpa_clicked',
        source_page: this.$route.fullPath,
        cta_position: 'Bottom CTA'
      })
    }
  }
}
</script>

<style scoped lang="scss">

.cta {
  top: -30px;
  margin-bottom: 55px;
  position: relative;

  @include breakpoint('tablet-portrait-up') {
    top: -15px;
  }

  .app-card {
    border-radius: 15px;
  }

  @include breakpoint('desktop-up') {
    margin: 100px 0;
  }

  &__heading {
    width: 240px;
    margin-left: auto;
    margin-right: auto;
    @include breakpoint('tablet-portrait-up') {
      margin-top: 50px;
      width: 100%;
      font-size: 24px;
      line-height: 30px;
    }
    @include breakpoint('tablet-portrait-up') {
      font-size: 36px;
      line-height: 42px;
    }
  }

  &__button {
    width: 225px;
    max-width: 270px;
    margin-bottom: 20px;
    @include breakpoint('tablet-portrait-up') {
      margin-top: 15px;
      margin-bottom: 50px;
    }
  }

  &__text {
    width: 305px;
    margin: 30px auto 40px auto;
    line-height: 25px;
    @include breakpoint('mobile-small-only') {
      width: 240px;
    }
    @include breakpoint('tablet-portrait-up') {
      width: 450px;
      margin-top: 30px;
      margin-bottom: 25px;
      font-size: 17px;
      line-height: 26px;
    }
  }
}
</style>
